import { render, staticRenderFns } from "./ViewUserProfile.vue?vue&type=template&id=85995524&scoped=true&"
import script from "./ViewUserProfile.vue?vue&type=script&lang=js&"
export * from "./ViewUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./ViewUserProfile.vue?vue&type=style&index=0&id=85995524&scoped=true&lang=scss&"
import style1 from "./ViewUserProfile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85995524",
  null
  
)

export default component.exports